<template>
  <pt-export-history class="pt-export-history__withData"></pt-export-history>
</template>

<script>
import PtExportHistory from './index'
export default {
  name: 'pt-export-history__withData',
  components: {
    'pt-export-history': PtExportHistory
  }

}
</script>
